import BaseService from "./BaseService";

class LearningObjectService {
  static async list(data) {
    const params = (data && BaseService.cleanQueryParams(data)) || {};
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/learning-objects?${queryParams}`);
  }

  static async create(data) {
    return await BaseService.callAPI(`/learning-objects`, "POST", data);
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/learning-objects/${id}`);
  }

  static async update({ id, payload }) {
    return await BaseService.callAPI(
      `/learning-objects/${id}`,
      "POST",
      payload
    );
  }
}

export default LearningObjectService;
